import React, {Component} from 'react'
import {Route, Switch, withRouter} from "react-router-dom";
import * as _ from 'lodash';
/** OWN COMPONENTS **/
import StationForm from '../AdminStations/StationForm/StationForm'
import {StationList} from './StationList/StationList'
import StationCharts from './StationCharts/StationCharts'
import StationMap from '../../Map';

/*** REDUX  ****/
import * as nodeChartsActions from '../../../actions/nodeCharts'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
/** REACT TOOLBOX ***/
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import NotFound from "../../Route/error404";
import {PropsRoute} from "../../Route";

class ManageStations extends Component {
    constructor() {
        super();

        this.state = {
            page: 0,
            stations: [],
        };

        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.handleSensorsPage = this.handleSensorsPage.bind(this);
    }

    componentDidMount() {
        if (this.props.organization.stations && this.state.stations.length === 0) {
            this.setState({
                ...this.state,
                stations: this.props.organization.stations,
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (this.props.organization.stations !== prevProps.organization.stations) {
            if (this.props.organization.stations) {
                let stations = [];

                this.props.organization.stations.forEach((station, key) => {
                    if (this.state.stations.length > key) {
                        if (!_.isEqual(_.omit(station, ['checked']), _.omit(this.state.stations[key], ['checked']))) {
                            if (station.id === this.state.stations[key].id)
                                station.checked = this.state.stations[key].checked;
                            stations.push(station);
                        } else
                            stations.push(this.state.stations[key]);
                    } else
                        stations.push(station);
                });

                this.setState({...this.state, stations});
            }
        }
    }

    handleSensorsPage(direction) {
        let aux = this.state.page;

        if (direction === "next" && this.state.count > (this.state.page + 1) * 20) {
            aux++;
            this.setState({...this.state, page: aux});
        }
        else if (direction === "previous" && this.state.page > 0) {
            aux--;
            this.setState({...this.state, page: aux});
        }
    }

    handleCheckBoxChange(key) {
        let stations = this.state.stations;

        stations[key].checked = !stations[key].checked;

        this.setState({...this.state, stations});
    }

    render() {

        return (
            <ThemeProvider theme={theme}>
                <div className="row dashboardContent">
                    <Switch>
                        <PropsRoute exact path="/stations" component={StationList}
                                    organization={this.props.organization.name}
                                    stations={this.state.stations}
                                    handleCheckBoxChange={this.handleCheckBoxChange}
                                    count={this.state.stations.length}
                                    page={this.state.page}
                                    handleSensorsPage={this.handleSensorsPage}
                                    />
                        <PropsRoute exact path="/dashboard" component={StationList}
                                    organization={this.props.organization.name}
                                    stations={this.state.stations}
                                    handleCheckBoxChange={this.handleCheckBoxChange}
                                    count={this.state.stations.length}
                                    page={this.state.page}
                                    handleSensorsPage={this.handleSensorsPage}
                                    />
                                    <Route exact path="/stations/map/:station" component={StationMap}/>
                        <Route exact path="/stations/chart/:stations/alias/:alias/from/:from/to/:to" component={StationCharts}/>
                        <Route exact path="/stations/chart/:stations/from/:from/to/:to" component={StationCharts}/>
                        <Route exact path="/stations/chart/:stations/from/:from" component={StationCharts}/>
                        <Route exact path="/stations/chart/:stations/alias/:alias/from/:from" component={StationCharts}/>
                        <Route exact path="/stations/chart/:stations/alias/:alias" component={StationCharts}/>
                        <Route exact path="/stations/chart/:stations" component={StationCharts}/>
                        <Route exact path="/stations/:id" component={StationForm}/>
                        <Route path='*' component={NotFound}/>
                    </Switch>
                </div>
            </ThemeProvider>
        )
    }

}

const stateToProps = (state) => {
    return {
        organization: state.user.currentOrganization,
    }
};


const DispatchToProps = (dispatch) => {
    return {
        nodeChartsActions: bindActionCreators(nodeChartsActions, dispatch),
    }
};
export default withRouter(connect(stateToProps, DispatchToProps)(ManageStations))



//
// handleNodeDashboard(nodes) {
//     this.props.nodeChartsActions.fetchDataFromNode(nodes.map(node => {
//         return node.station_id
//     }), localStorage.getItem('x-auth-token'));
//
//     this.props.dashboardActions.changeDashboardContent({
//         content: 'nodes', view: 'dashboard', nodes:
//             nodes.map(node => {
//                 return node.alias
//             })
//     });
// }


// WEBPACK FOOTER //
// ./src/components/DashBoard/ManageStations/index.js